export default "__VITE_ASSET__sG97esg1__"